var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDontTouch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.736 424.007L290.012 48.7122C282.996 36.5617 270.031 29.0781 255.999 29.0781C241.969 29.0781 229.003 36.5602 221.987 48.7122L5.26273 424.007C-1.75633 436.157 -1.75633 451.132 5.25962 463.284C12.2756 475.436 25.2417 482.923 39.2752 482.923H472.723C486.755 482.923 499.723 475.438 506.739 463.284C513.753 451.132 513.753 436.157 506.736 424.007ZM39.2752 443.647L255.999 68.3526L472.723 443.647H39.2752Z",
    fill: "#533E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.812 203.568L240.076 332.515C240.733 340.106 246.757 346.362 254.609 347.048C263.404 347.818 271.156 341.31 271.924 332.515L283.187 203.568C283.309 202.061 283.324 200.372 283.187 198.819C281.876 183.802 268.641 172.694 253.626 174.003C238.611 175.316 227.501 188.554 228.812 203.568Z",
    fill: "#533E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 400.093C268.441 400.093 278.526 390.007 278.526 377.566C278.526 365.125 268.441 355.039 256 355.039C243.558 355.039 233.473 365.125 233.473 377.566C233.473 390.007 243.558 400.093 256 400.093Z",
    fill: "#533E37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontTouch);
export default __webpack_public_path__ + "static/media/dontTouch.cf02cd53d6c1fefdc1f02b773ba8d229.svg";
export { ForwardRef as ReactComponent };